import { gql } from '@lcs/shared/api';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const SaveExtensionGroupMutation = gql`
   mutation SaveExtensionGroup(
      $extensionGroup: ExtensionGroupInput!
      $deletedExtensionGroupExtensionMemberIds: [UInt!]!
      $hasDeletedExtensionGroupExtensionMembers: Boolean = false
   ) {
      deleteExtensionGroupExtensions(ids: $deletedExtensionGroupExtensionMemberIds)
         @include(if: $hasDeletedExtensionGroupExtensionMembers)
      extensionGroup: saveExtensionGroup(extensionGroup: $extensionGroup) {
         extensionGroupId
         accountId
         name
         description
         extensionGroupExtensionsConnection {
            items {
               extensionGroupExtensionId
               extensionGroupId
               extensionId
            }
         }
      }
   }
`;
